import {constants} from "../constants/constants";

export const parsePhoneToInternational = (currency, phone) => {
    let parsedPhone;
    const curr = currency?.toLowerCase() ?? constants.defaultCurrency;
    if (phone) {
        parsedPhone = currencyPhoneMapping[curr]?.(phone);
    }
    return parsedPhone;
}

const currencyPhoneMapping = {
    ils: convertToIsraelPhone,
    usd: convertToUsPhone,
    mxn: convertToMexicoPhone
}

function convertToIsraelPhone(phone) {
    if (phone[0] === '+' || phone[0] === '9') {
        return phone;
    } else if (phone[0] === '0') {
        return phone.replace('0', '972');
    } else if (phone[0] === '5') {
        return `${constants.phoneNumbers.ISRAEL_PREFIX_CODE}${phone}`;
    }
}

function convertToUsPhone(phone) {
    const phoneDigitsOnly = phone.replace(/\D/g, '');
    if (phoneDigitsOnly.startsWith(constants.phoneNumbers.USA_PREFIX_CODE) && phoneDigitsOnly.length === 11) {
        return `${phoneDigitsOnly}`;
    } else if (phoneDigitsOnly.length === 10) {
        return `${constants.phoneNumbers.USA_PREFIX_CODE}${phoneDigitsOnly}`;
    }
}

function convertToMexicoPhone(phone) {
    if (phone.length === 10) {
        return `${constants.phoneNumbers.MEXICO_PREFIX_CODE}${phone}`;
    } else if (phone.length > 10 && phone[0] === '5' && phone[1] === '2') {
        return phone;
    }
}

/**
 * @param {string} email
 * @param {(string) => string} translation
 * @param {boolean} isAdmin
 * @return {string}
 */
export const getCreatedByPaymentPlanValue = (email, translation, isAdmin = false) => {
    if (!email) {
        return translation('reports.tenant');
   // the creator is a normal manager
    } else if (!email.includes('bllink.co')) {
        return email
    }else {
        return isAdmin ? email :  translation('titles.bllink');
    }
}
